import { Controller, useFormContext } from "react-hook-form";

import { NcFieldLayout, ncFieldLayoutClasses } from "./nc-field-layout";
import { NcSwitch, NcSwitchProps } from "./nc-switch";

export interface NcFormSwitchProps extends Omit<
  NcSwitchProps,
  "name" | "validate" | "onBlur" | "isSelected" | "value" | "validationBehavior" | "children"
> {
  name: string; // Was optional in NcSwitchProps and is now required
  label: string;
  description?: string;
}

export const NcFormSwitch = ({
  name,
  label,
  description,
  onChange,
  ...props
}: NcFormSwitchProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { error },
      }) => (
        <NcFieldLayout>
          <NcSwitch
            ref={ref}
            name={name}
            onBlur={onBlur}
            onChange={value => {
              onChange?.(value);
              formOnChange(value);
            }}
            isSelected={value}
            {...props}
          >
            {label}
          </NcSwitch>
          {description && <NcFieldLayout.Description>{description}</NcFieldLayout.Description>}
          {error && <div className={ncFieldLayoutClasses.error}>{error?.message}</div>}
        </NcFieldLayout>
      )}
    />
  );
};
